<template>
  <div class="love" v-if="date">
    <audio :src="mus" preload ref="MusicPlay"></audio>
    <!-- <img class="music" :style="isPlay ? 'animation-name: music;' : ''" @click="musicPausePlay" src="../assets/music.png" alt="" :title="isPlay ? '暂停' : '播放'"> -->
    <div class="container1">
      <div class="top">
        <h2 class="title">我爱的人F</h2>
        <div class="text">F LOVE F 一生一世</div>
      </div>

      <div class="content1">
        <div class="text">
          <p>咱两初次见面至今已经{{date.time}}，共计{{date.hour}}、{{date.minute}}、{{date.second}}。</p>
          <p>可能第一次见面也没给你留下什么好的印象，之前只是断断续续的在联系。中间也有“不正经”的跟你说喜欢你，你说一直把我当成朋友，我呢也就含糊着。我知道我的情商很低，不会说好听动情的话语。不知道怎么去哄一个自己喜欢的人！</p>
          <p>最近两年左右的时间里，也没有再联系过！不过基本每天都会去看你的朋友圈与微博有没有更新新的动态，过的怎么样，开不开心，有没有什么烦心的事。每次看到你发表自己受伤了，心情烦躁，自己心里也跟着烦躁。多想当时就在你身边抱着你，陪着你！当看到你发表很开心的事时，不管有什么烦心的事好像都没了，不由自主的也有高兴。</p>
          <p>我知道我现在过得很狼狈，配不上你。但我还是想对你说：“<span style="color: rgb(5, 91, 170);">我不是一个善言谈的人，但是以后我会用我的实际行动让你感觉到，我是真的很爱你的，所以希望你给我一个照顾你一辈子的机会，然后一起慢慢变老，好吗？</span><span style="color: rgb(223, 8, 8);">徐晓凤，我喜欢你、我喜欢你、我喜欢你！”</span></p>
        </div>

        <div class="music-card">
          <p style="padding-bottom: 20px;">前不久企鹅点歌台为你点的歌</p>
          <div class="progress">
            <div class="progress-a"></div>
            <div class="progress-b" :style="{width: w + '%'}"></div>
            <!-- <div class="duration">
              <span>{{playDuration}}</span>
              <span>{{duration}}</span>
            </div> -->
          </div>
          <img :src="isPlay ? require('../assets/pause.png') : require('../assets/play.png')" alt="" @click="musicPausePlay">
        </div>

        <div class="my-lover-img">
          <img src="../assets/myLover.jpg" alt="">
        </div>

        <p style="font-size: 30px; padding: 20px; text-align: center;" class="aaa">如果你看完了这个希望你给我一次从新追求你的机会！</p>
      </div>
    </div>
  </div>
</template>

<script>
  var timing
  var timer
  export default {
    name: 'myLover',
    metaInfo () {
      return {
        title:'my Lover'
      }
    },

    data() {
      return {
        isPlay: false,
        mus: require('../assets/music/1.mp3'),
        date: '',
        w: 0,
        duration: '',
        playDuration: ''
      }
    },

    mounted () {
      this.date = this.getDate()
      timing = setInterval(() => {
        this.date = this.getDate()
      }, 1000)
      // setTimeout(() => {
      //   let audio = this.$refs.MusicPlay
      //   if (audio.readyState > 0) {
      //     this.duration = this.s_to_hs(parseInt(audio.duration))
      //     this.playDuration = this.s_to_hs(0)
      //   }
      // }, 500)
    },

    methods: {
      // audio: () => {
      //   this.$nextTick(() => {
      //     this.$refs.MusicPlay.play()
      //   })
      // },
      //播放暂停
      musicPausePlay () {
        this.isPlay = !this.isPlay
        let audio = this.$refs.MusicPlay
        if(this.isPlay) {
          this.$refs.MusicPlay.play()
          // if (audio.readyState > 0) {
            // let duration = parseInt(audio.duration)
            let duration = 283
            // let currentTime = parseInt(audio.currentTime)
            let w = 100 / duration
            // this.duration = this.s_to_hs(parseInt(audio.duration))
            // this.playDuration = this.s_to_hs(currentTime)
            timer = setInterval(() => {
              this.w = this.w + w
              // this.playDuration = this.s_to_hs(currentTime ++)
              if(this.w >= 100) {
                clearInterval(timer)
                this.isPlay = !this.isPlay
              }
            }, 1000)
          // }
        } else {
          clearInterval(timer)
          this.$refs.MusicPlay.pause()
        }
      },

      getDate () {
        let t = new Date('2016/06/09 10:00:00').getTime()
        let now = new Date().getTime()
        let elapsed = parseInt(now / 1000 - t / 1000)
        let d = parseInt(elapsed / (3600 * 24))//计算出相差天数
        let h = parseInt((elapsed / 3600) % 24)//扣除相差天数，计算出相差小时数
        let m = parseInt((elapsed / 60) % 60)//扣除相差天数，小时数，计算出相差分钟数
        let s = parseInt(elapsed % 60)//扣除相差天数、小时数、分钟数相差数，计算出相差秒速
        let time = d + '天' + h + "小时" + m + "分" + s + "秒"

        let hour = parseInt(elapsed / 3600).toLocaleString() + ' 小时'
        let minute = parseInt(elapsed / 60).toLocaleString() + ' 分钟'
        let second = elapsed.toLocaleString() + ' 秒'
        let date = {
          time,
          hour,
          minute,
          second
        }
        return date
      },

      //时间转换
      s_to_hs (s) {
        //计算分钟
        //算法：将秒数除以60，然后下舍入，既得到分钟数
        var h
        h = Math.floor(s / 60)
        //计算秒
        //算法：取得秒%60的余数，既得到秒数
        s = s % 60
        //将变量转换为字符串
        h += ''
        s += ''
        //如果只有一位数，前面增加一个0
        h = (h.length == 1) ? '0' + h : h
        s = (s.length == 1) ? '0' + s : s
        return h + ':' + s
      },
    },

    destroyed() {
      clearInterval(timing)
    },
  }
</script>

<style lang="less" scoped>
  @font-face {  
    font-family: 'fanti'; 
    src: url('../assets/fonts/kaiti-2.ttf');  
    font-weight: normal;  
    font-style: normal;  
  }

  .love {
    // height: 100%;
    
    .music {
      position: fixed;
      z-index: 99;
      top: 20px;
      left: 20px;
      width: 30px;
      height: 30px;
      cursor: pointer;
      animation-duration: 3s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      transform-origin: center center;
    }

    .container1::before {
      content: '';
      display: block;
      width: 100%;
      height: 130px;
    }

    .container1 {
      background-color: rgb(99, 27, 5);
      height: 100%;

      .top {
        position: fixed;
        z-index: 9;
        top: 0;
        left: 0;
        width: 100%;
        height: 130px;
        background-color: rgb(99, 27, 5);

        .title {
          letter-spacing: 5px;
          color: rgb(230, 13, 183);
          font-size: 40px;
          text-align: center;
          text-shadow: 0px 1px 0px #999, 0px 2px 0px #888, 0px 3px 0px #777, 0px 4px 0px #666, 0px 5px 0px #555, 0px 6px 0px #444, 0px 7px 0px #333, 0px 8px 7px #001135;
        }

        .text {
          background-image: -webkit-linear-gradient(left,rgb(0, 0, 255),rgb(102, 255, 255) 10%,rgb(204, 0, 255) 20%,rgb(204, 0, 204) 30%, rgb(204, 204, 255) 40%, rgb(0, 255, 255) 50%,rgb(204, 204, 254) 60%,rgb(204, 0, 204) 70%,rgb(204, 0, 255) 80%,rgb(102, 255, 255) 90%,rgb(0, 0, 255) 100%);
          -webkit-text-fill-color: transparent;/* 将字体设置成透明色 */
          background-clip: text;
          -webkit-background-clip: text;/* 裁剪背景图，使文字作为裁剪区域向外裁剪 */
          background-size: 200% 100%; 
          -webkit-background-size: 200% 100%; 
          -webkit-animation: myAnimation 3s linear infinite;
          animation: myAnimation 3s linear infinite;
          height: 80px;
          width: 100%;
          line-height: 80px;
          letter-spacing: 5px;
          font-size: 30px;
          text-align: center;
          font-family: 'fanti';
        }
      }

      .content1 {
        padding: 20px;
        box-sizing: border-box;

        .text {
          line-height: 30px;

          p {
            text-indent: 2rem;
            padding-bottom: 20px;
          }
        }

        .my-lover-img {
          width: 90%;
          margin: auto;

          img {
            width: 100%;
          }
        }

        .music-card {
          border-radius: 10px;
          background-color: rgb(43, 31, 31);
          margin-bottom: 20px;
          color: #fff;
          padding: 20px;
          position: relative;

          .progress {
            width: 75%;
            position: relative;

            .progress-a {
              width: 100%;
              height: 5px;
              border-radius: 5px;
              background-color: #6d7077;
            }

            .progress-b {
              position: absolute;
              top: 0;
              height: 5px;
              border-radius: 5px;
              background-color: rgb(99, 27, 5);
            }

            .duration {
              display: flex;
              justify-content: space-between;
              margin-top: 3px;
              font-size: 12px;
            }
          }

          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            position: absolute;
            right: 15px;
            bottom: 20px;
          }
        }

        .aaa {
          letter-spacing: 5px;
          color: rgb(230, 13, 183);
          font-size: 40px;
          text-align: center;
          text-shadow: 0px 1px 0px #999, 0px 2px 0px #888, 0px 3px 0px #777, 0px 4px 0px #666, 0px 5px 0px #555, 0px 6px 0px #444, 0px 7px 0px #333, 0px 8px 7px #001135;
          font-family: 'fanti';
        }
      }
    }
  }


  @keyframes music {
    0%{-webkit-transform:rotate(0deg);}
    25%{-webkit-transform:rotate(90deg);}
    50%{-webkit-transform:rotate(180deg);}
    75%{-webkit-transform:rotate(270deg);}
    100%{-webkit-transform:rotate(360deg);}
  }

  @keyframes myAnimation {
		0% {
			background-position: 0  0;
      // transform: translateX(300px);
		}
		100% {
			background-position: -100%  0;
      // transform: translateX(-300px);
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/myLover.vue